import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import * as moment from "moment";
import { CoreConfigService } from "@core/services/config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../auth/service/absences.service";
import { locale as italian } from "../../../../i18n/it";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit {
  public contentHeader: IContentHeader;
  public identifier: string;
  public isMyProfile: boolean = true;
  public currentUser: any;
  public eccTableIndex: string = "";
  public config: any;
  public me: ICurrentUser;
  public last5years: Array<number> = [];
  public currentYear: number = moment().year();
  public selectedYearAbsence: number = moment().year();
  public currentExperience: any;
  public demand_modal_data: any = [];
  public demand_user: any = [];
  public all_absences: Array<{ name: string; amount: number }> = [];
  public userCommissions: any = [];
  public totalRevenue: number = 0;
  public totalCost: number = 0;
  public totalMarginPercentage: string = "0";
  public totalMarginCurrency: number = 0;
  public commissionsFilterYear: number = moment().year();
  public commissionsFilterMonth: number = moment().month();
  public availableMonths: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  public availableYears: number[] = [];
  public commissionsIsLoading: boolean = false;

  constructor(
    public _utilService: UtilsService,
    private _userService: UserService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    private activated_route: ActivatedRoute,
    private _coreConfigService: CoreConfigService,
    public _modalService: NgbModal,
    private _absenceService: AbsencesService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.PROFILE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: this._authenticationService.hasCapability("show_menu_employee_list") ? italian.data.MENU.EMPLOYEE_LIST : italian.data.MENU.ADDRESS_BOOK,
            isLink: true,
            link: this._authenticationService.hasCapability("show_menu_employee_list") ? "/dashboard/user/list/employee" : "/dashboard/address-book",
          },
          {
            name: italian.data.MENU.PROFILE,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.me = this._authenticationService.getCurrentUser();
    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      if (params.get("user_identifier")) {
        this.identifier = params.get("user_identifier");
        this.isMyProfile = this.identifier === this.me.hash;
      } else {
        this.identifier = this.me.hash;
        this.isMyProfile = true;
      }

      this.loadCommissions();

      this.currentUser = await this._userService.get(this.identifier).catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "NOT_FOUND_USER" });
        await this.router.navigateByUrl("/dashboard/user/list/employee");
        return false;
      });

      if (!this.currentUser) {
        await this.router.navigateByUrl("/dashboard/user/list/employee");
        return false;
      }

      this.currentUser.isCollaborator = this._utilService.isACollaborator(this.currentUser);

      if (this.currentUser.hasOwnProperty("has_child")) {
        this.currentUser.has_child = this.currentUser.has_child === null ? null : this.currentUser.has_child;
      }

      this.currentUser.registration_date = this.currentUser.registration_date ? moment.utc(this.currentUser.registration_date) : null;

      if (this.currentUser.experiences && this.currentUser.experiences.length > 0) {
        this.eccTableIndex = "experience";
      } else if (this.currentUser.skills && this.currentUser.skills.length > 0) {
        this.eccTableIndex = "skill";
      } else if (this.currentUser.certifications && this.currentUser.certifications.length > 0) {
        this.eccTableIndex = "certification";
      } else {
        this.eccTableIndex = "language";
      }

      this.contentHeader.breadcrumb.links[2].name = this.currentUser.complete_name;

      // genero l'array per il filtro dell'anno
      for (let y = 2023; y <= moment().year(); y++) {
        this.availableYears.push(y);
      }
    });

    this._coreConfigService.config.subscribe((params: any) => {
      this.config = params.custom;
    });

    this.demand_user = await this._absenceService.getMineAbsences();

    this.allAbsences(null);
    this.last5years = [0, 1, 2, 3, 4].map((count) => this.currentYear - count);

    //Metto come primo elemento l'educazione selezionata come primaria
    if (this.currentUser && this.currentUser.educations && this.currentUser.educations.length > 1) {
      this.currentUser.educations = this.currentUser.educations.sort((a) => a.primary);
    }

    setTimeout(() => this._utilService.hideLoading(), 700);
  }

  public async loadCommissions() {
    //reset commesse utente
    this.userCommissions = [];
    this.commissionsIsLoading = true;
    await this._userService.getCommissions(this.identifier, Number(this.commissionsFilterMonth) + 1, this.commissionsFilterYear)
      .then((results: any) => {
        this.userCommissions = [];
        this.totalCost = 0;
        this.totalMarginCurrency = 0;
        this.totalRevenue = 0;
        this.totalMarginPercentage = "0";
        if (results.commissions || results.structures) {
          for (const commission of results.commissions) {
            let commissionObj: any = {
              client: {
                name: commission.name,
              },
              type: "commission",
              commission_id: commission.commission_id,
              complete_name: `${commission.name} - ${commission.commission_name}`,
              analytics: {
                real_cost: 0, //3000.0,
                real_profit: 0, //3500.0,
                margin_percentage: 0, //20,
                margin_currency: 0, //300,
              },
              to: commission.end_date,
            };

            for (const analytic of (commission?.analytics?.employees_analytics || [])) {
              if (analytic.hash === this.identifier) {
                commissionObj.analytics.real_cost += analytic.real_cost;
                commissionObj.analytics.real_profit += analytic.real_profit;
                commissionObj.analytics.margin_currency += analytic.margin_currengy;
                commissionObj.analytics.margin_percentage += analytic.margin_percentage;
              }
            }

            this.userCommissions.push(commissionObj);
          }

          const companyName: string = this._utilService.themeConfiguration.company_nicename.toUpperCase();
          for (const structure of results.structures) {
            const completeName: string = `${companyName} - ${structure.description}`;
            this.userCommissions.push({
              structure_id: structure.id,
              complete_name: completeName,
              to: structure.end_date,
              type: "structure_cost",
              analytics: {
                real_cost: Number(structure.amount),
                real_profit: 0,
                margin_percentage: Number(structure.margin_currengy || 0),
                margin_currency: Number(structure.margin_percentage || 0),
              },
            });
          }
        }

        this.commissionsIsLoading = false;
      });

    if (!this.userCommissions) {
      this.userCommissions = [];
    }
    //Calcolo i totali
    if (this.userCommissions && this.userCommissions.length > 0) {
      this.userCommissions.map((item) => {
        this.totalCost += item.analytics.real_cost || 0;
        this.totalRevenue += item.analytics.real_profit || 0;
      });
    }
    //Calcolo margine totale
    this.totalMarginCurrency = this.totalRevenue - this.totalCost;
    const multiplicationTotalMargin: number = this.totalMarginCurrency * 100;
    //Controllo che siano maggiori di zero. Se entrambi fossero di valore zero il risultato sarebbe NaN
    if (!!multiplicationTotalMargin && this.totalRevenue) {
      this.totalMarginPercentage = (multiplicationTotalMargin / this.totalRevenue).toFixed(2);
    }
  }

  async goToContract() {
    if (!this._authenticationService.hasCapability("view_others_documents")) {
      return false;
    }
    await this.router.navigate(["/dashboard/user/edit/", this.currentUser.hash], { queryParams: { section: "contract" } });
  }

  public allAbsences(event: any = null) {
    let demandUser: any;
    event ? (this.selectedYearAbsence = Number(event.target.value)) : null;
    event
      ? (demandUser = this.demand_user.filter((item: any) => item.status === 1 && (item.from.includes(event.target.value) || item.to.includes(event.target.value))))
      : (demandUser = this.demand_user.filter((item: any) => item.status === 1 && (item.from.includes(this.currentYear) || item.to.includes(this.currentYear))));
    let list: any = {};

    demandUser.map((item: any) => {
      const currentCategory: string = String(item.type.category).trim();
      if (!list[currentCategory]) {
        list[currentCategory] = 0;
      }
      if (item.from === item.to) {
        //Se la data è uguale setto che ha preso soltanto un giorno di ferie o malattia
        list[currentCategory] += 1;
      } else {
        if (currentCategory === "permesso") {
          //Controllo per settare le ore dei permessi
          const from: moment.Moment = moment(item.from);
          const to: moment.Moment = moment(item.to);
          //Controllo per la pausa pranzo nel caso dalla differenza togliamo un ora
          if (from.hours() >= 9 && from.hours() <= 13 && to.hours() >= 14 && to.hours() <= 18) {
            list[currentCategory] += to.diff(from, "minutes") / 60 - 1;
          } else {
            list[currentCategory] += to.diff(from, "minutes") / 60;
          }
        } //Se la data e diversa calcola la differenza tra item.from e item.to
        list[currentCategory] += this._utilService.calculateDifferenceBetweenDates(item.from, item.to);
      }
    });
    this.all_absences = [];
    list.ferie = list.ferie || 0;
    list.permesso = list.permesso || 0;
    list.malattia = list.malattia || 0;
    list.infortunio ? (list.malattia += list.infortunio) : list.malattia;
    list.infortunio ? delete list.infortunio : null;
    list.maternità > 0 ? (list.malattia += list.maternità) : list.malattia;
    list.maternità > 0 ? delete list.maternità : null;
    Object.keys(list).map((category: string) => {
      this.all_absences.push({ name: category, amount: list[category] });
    });
    this.all_absences = this.all_absences.sort((a, b) => a.name.localeCompare(b.name));
  }

  public openModalAbsences(modal, category: string, year) {
    this.demand_modal_data = this.demand_user.filter((item: any) => item.type.category === category && item.from.includes(year));
    if (this.demand_modal_data.length > 0) {
      this.demand_modal_data = this.demand_modal_data.map((item) => {
        item.date_from = this._utilService.formatDate(item.from);
        item.date_to = this._utilService.formatDate(item.to);
        return item;
      });
      this._modalService.open(modal, {
        size: "lg",
        centered: true,
      });
    }
  }

  openModalExperiences(modal, experience: any) {
    this.currentExperience = experience;
    this._modalService.open(modal, {
      size: "lg",
      centered: true,
    });
  }

  formatMonth(month: any, format: string = "MMMM") {
    const date: moment.Moment = moment();
    date.set("month", month);
    return date.format(format);
  }
}
